import React from 'react';
import ManageLabels from '../components/TerminalLabels/ManageLabels';
import AdminRouteGate from '../components/feedback/AdminRouteGate';

/**
 * Exception-label generation is admin-only.
 *
 * The five endpoints behind this screen are all IsAdmin-gated, so a vendor who
 * reached it could not actually create anything — but they would get the whole
 * wizard and a 403 on the first keystroke. Bounce them to Orders instead of
 * rendering a screen that cannot work.
 *
 * The gate keeps that posture while distinguishing "you are not an admin" from
 * "we could not check": the first redirects, the second says so and offers a
 * retry rather than silently sending an admin away mid-deploy.
 */
function TerminalLabels() {
  return (
    <AdminRouteGate>
      <ManageLabels />
    </AdminRouteGate>
  );
}

export default TerminalLabels;
